class SwiperMarquee extends HTMLElement {
    constructor() {
        super();
    }
    
    connectedCallback() {
        const initSwiper = () => {
            const swiperEl = this.querySelector('.swiper');
            const slideEls = swiperEl.querySelectorAll('.swiper-slide');

            if (slideEls.length <= 1) {
                const pagination = this.querySelector('.swiper-pagination');
                const nextBtn = this.querySelector('.swiper-button-next');
                const prevBtn = this.querySelector('.swiper-button-prev');
                const swiperButtonWrapper = this.querySelector('.swiper-buttons-wrapper');
        
                pagination?.classList.add('hidden');
                nextBtn?.classList.add('hidden');
                prevBtn?.classList.add('hidden');
                swiperButtonWrapper?.classList.add('hidden');
                return; 
            }

            const slidesPerView = parseFloat(this.dataset.slidesPerView) || 1.2;
            const spaceBetween = parseInt(this.dataset.spaceBetween) || 16;
            const loop = this.dataset.loop === 'true';
            const paginationType = this.dataset.paginationType;
            const autoHeight = this.hasAttribute('data-auto-height');
            const effect = this.dataset.effect || 'slide';
            const enableAutoplay = this.dataset.autoplay === 'true';
            const autoplayDelay = parseInt(this.dataset.autoplayDelay) || 3000;
            
            let breakpoints = {};
            if (this.dataset.breakpoints) {
                try {
                    breakpoints = JSON.parse(this.dataset.breakpoints);
                    Object.keys(breakpoints).forEach(key => {
                        if (breakpoints[key].slidesPerView) {
                            breakpoints[key].slidesPerView = parseFloat(breakpoints[key].slidesPerView);
                        }
                        if (breakpoints[key].spaceBetween) {
                            breakpoints[key].spaceBetween = parseInt(breakpoints[key].spaceBetween);
                        }
                    });
                } catch (e) {
                    console.error('Invalid breakpoints JSON:', e);
                }
            }

            const swiperConfig = {
                autoHeight: autoHeight ? true : false,
                calculateHeight: true,
                direction: 'horizontal',
                loop: loop,
                slidesPerView: slidesPerView,
                spaceBetween: spaceBetween,
                grabCursor: true,
                effect: effect,
                fadeEffect: {
                    crossFade: true
                },
                autoplay: enableAutoplay ? {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                } : false,
                pagination: {
                    el: '.swiper-pagination',
                    type: paginationType,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: breakpoints
            };

            // Initialize Swiper with the config
            const swiper = new Swiper(swiperEl, swiperConfig);

            // Add fade transition classes if effect is fade
            if (effect === 'fade') {
                swiperEl.classList.add('swiper-fade');
                slideEls.forEach(slide => {
                    slide.classList.add('swiper-fade-slide');
                });
            }
        }

        initSwiper();
    }
}

customElements.define('swiper-marquee', SwiperMarquee);